<div class="d-flex navigation-header">
    <h1 (click)="goBack()" id="panel">{{"admin.title" | translate }}</h1>
    <h1>&nbsp; > {{"admin.channel.title" | translate}}</h1>
    <button mat-flat-button color="primary" (click)="openNewVideoDialog()" class="action-button" [ngClass]="(isEnglish()) ? 'action-button-en' : 'action-button-de'">{{'admin.channel.addNew' | translate}}</button>
</div>
<div class="container-card d-flex" *ngIf="(videos$ | async)">
    <div *ngFor="let video of (videos$ | async)" class="video-card">
        <app-youtube-video [video]="video" [isSuperAdmin]="true" (saveUpdateVideo)="saveUpdateVideo($event)" (deleteVideo)="deleteVideo($event)"></app-youtube-video>
    </div>
</div>
